var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 32,
    viewBox: "0 0 23 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1351 11.6817L12.0063 14.5786L9.10206 8.75066L10.6024 5.39967C10.9816 4.73124 11.6018 4.72241 11.981 5.39967L15.1351 11.6817Z",
    fill: "#FFA000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0076 14.5774L0.304298 25.4022L9.10335 8.75066L12.0076 14.5774Z",
    fill: "#F57F17"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5657 7.2511C19.1262 6.72014 19.7033 6.89923 19.8491 7.65342L22.8916 25.2559L12.8003 31.2806C12.4464 31.4774 11.5079 31.5543 11.5079 31.5543C11.5079 31.5543 10.6544 31.4509 10.3272 31.2718L0.304298 25.4022L18.5657 7.2511Z",
    fill: "#FFCA28"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10334 8.75066L0.304298 25.4022L4.22569 1.06369C4.37281 0.309501 4.80274 0.232568 5.19082 0.901L9.10334 8.75066Z",
    fill: "#FFA000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.72f16380bf061de9c0b6cf2a58f03411.svg";
export { ForwardRef as ReactComponent };